<hamburger-menu *ngIf="isCompactScreen && hasMoreThanOneOption" [class.hidden]="hideHamburgerMenu" [view]="view" [isOpen]="isHamburgerMenuOpen"
                (toggleOpen)="toggleHamburgerMenu($event)"></hamburger-menu>
<div class="basic-category-menu controls-menu-container" [class.menu-closed]="!isControlsMenuOpen" *ngIf="hasMoreThanOneOption">
  <hamburger-menu *ngIf="!isCompactScreen" [class.hidden]="hideHamburgerMenu" [view]="view" [isOpen]="isHamburgerMenuOpen"
                  (toggleOpen)="toggleHamburgerMenu($event)"></hamburger-menu>
  <div class="menu-collapse-btn">
    <icon class="carrot_arrow" name="carrot_arrow" [class.flip]="!isControlsMenuOpen" (click)="toggleControlMenu()"></icon>
    <div class="carrot-message" [class.show-message]="showCarrotMessage">
      <div class="close-carrot-message" (click)="closeCarrotMessage()">x</div>
      <div (click)="toggleControlMenu()">
        Touch or click here to view additional selections.
      </div>
    </div>
  </div>
  <div class="controls-menu">
    <button mat-button color="primary" class="reset-btn" [disabled]="disableResetButton" (click)="onResetClicked()">
      <icon name="reset_arrow"></icon><span>Reset</span>
    </button>
    <div class="category-container">

      <div class="view-group category-body-option" *ngIf="showToursInMenu">

        <div class="category-header flex row align-center justify-between" [class.open]="tourAccordion.IsOpen"
             (click)="toggleCategoryMenu(tourAccordion)">
          <div>
            <div><span *ngIf="showOptionsCounter" class="options-count">{{tourAccordion?.ChildItems?.length}}</span>{{tourAccordion?.Name}}</div>
            <div class="sub">
              <icon name="success"></icon>{{tourAccordion.getSelectedOption()?.Name}}
            </div>
          </div>
          <div class="expander">
            <icon name="line" [class.open]="tourAccordion.IsOpen"></icon>
            <icon name="line"></icon>
          </div>
        </div>
        <div class="category-body" [@heightExpandCollapse]="tourAccordion?.AnimationState">
          <div *ngFor="let item of tourAccordion?.ChildItems" class="category-body-option flex row align-center justify-between"
               [class.selected]="item.IsSelected" (click)="handleTourSelect(item)">
            <div class="label-container">
              {{item.Name}}
            </div>
            <div class="icon-container">
              <icon name="success"></icon>
            </div>
          </div>
        </div>

      </div>

      <div class="view-group category-body-option" *ngIf="view.ViewSettings?.DisplayViewGroupsAboveCategories">
        <ng-container *ngFor="let accordion of viewGroupAccordions">
          <div class="category-header flex row align-center justify-between" [class.open]="accordion.IsOpen" (click)="toggleCategoryMenu(accordion)">
            <div>
              <div><span *ngIf="showOptionsCounter" class="options-count">{{accordion?.ChildItems?.length}}</span>{{accordion?.Name}}</div>
              <div class="sub">
                <icon name="success"></icon>{{accordion.getSelectedOption()?.Name}}
              </div>
            </div>
            <div class="expander">
              <icon name="line" [class.open]="accordion.IsOpen"></icon>
              <icon name="line"></icon>
            </div>
          </div>
          <div class="category-body" [@heightExpandCollapse]="accordion?.AnimationState">
            <div *ngFor="let item of accordion?.ChildItems" class="category-body-option flex row align-center justify-between"
                 [class.selected]="item.IsSelected" (click)="handleViewSelect(item)">
              <div class="label-container">
                {{item.Name}}
              </div>
              <div class="icon-container">
                <icon name="success"></icon>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <ng-container *ngFor="let category of view?.Categories">
        <ng-container *ngIf="category.Settings.ShowCategory">
          <div class="category-header flex row align-center justify-between" [class.open]="category.IsOpen" (click)="toggleCategoryMenu(category)"
               *ngIf="pano.ShowSingleOptionCategory || category.Options.length > 1">
            <div>
              <div><span *ngIf="showOptionsCounter" class="options-count">{{category.Options.length}}</span>{{category.Name}}</div>
              <div class="sub">
                <icon name="success"></icon>{{category.getSelectedOption()?.Name}}
              </div>
            </div>
            <div class="expander">
              <icon name="line" [class.open]="category.IsOpen"></icon>
              <icon name="line"></icon>
            </div>
          </div>
          <div class="category-body" [@heightExpandCollapse]="category?.AnimationState">
            <div *ngIf="category.HasOptionThumbnails; else listTemplate" class="category-grid">
              <option-grid-item *ngFor="let option of category?.Options" [option]="option" [class.disabled]="!option.enabled"
                                (optionSelect)="selectOption(option, category)">
              </option-grid-item>
            </div>
            <ng-template #listTemplate>
              <option-list-item *ngFor="let option of category?.Options" [option]="option" (optionSelect)="selectOption(option, category)">
              </option-list-item>
            </ng-template>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!view.ViewSettings?.DisplayViewGroupsAboveCategories">
        <menu-accordion *ngFor="let accordion of viewGroupAccordions" [model]="accordion" (itemSelect)="handleViewSelect($event)"></menu-accordion>
      </ng-container>
    </div>
  </div>
</div>